<template>
    <div v-if="content">
        <span v-html="paperStyle"></span>
        <section class="paper">
            <div class="header">
                <h1>ใบรับเคลมสินค้า</h1>
                <div class="issue">
                    <div>วันที่ {{ $AppUtility.displayOnlyDate(content.data.openDate) }}</div>
                </div>
            </div>

            <div class="document-data">
                <div class="left">
                    <div class="text-strong">ร้านค้าผู้ให้บริการ</div>
                    <div>{{ content.store.info.name }}</div>
                    <div>เลขประจำตัวผู้เสียภาษี {{ content.store.info.taxId }}</div>
                    <div>{{ [ content.store.info.address, content.store.info.subDistrict, content.store.info.district, content.store.info.province, content.store.info.postCode ].join(' ') }}</div>
                    <div>เบอร์โทร {{ content.store.info.tel }}</div>
                </div>
                <div class="right">
                    <div class="text-strong">รายละเอียดลูกค้า</div>
                    <div>ชื่อลูกค้า {{ content.data.customer.billName }}</div>
                    <div>เลขประจำตัวผู้เสียภาษี {{ customerTaxId }}</div>
                    <div>ผู้ติดต่อขอเคลม {{ [ content.data.customer.claimFirstName, content.data.customer.claimLastName ].join(' ') }}</div>
                    <div>เบอร์ติดต่อ {{ content.data.customer.claimTel }}</div>
                    <div>ข้อมูลรถ {{ getLicensePlateData() }}</div>
                    <div>{{ getCarData() }}</div>
                </div>
            </div>

            <div class="bill-no">เลขที่ {{ content.data.number }}</div>

            <table cellpadding="0" cellspacing="0">
                <tr>
                    <th width="5%" class="text-center"></th>
                    <th width="40%">สินค้าขอเคลม</th>
                    <th class="text-center">สัปดาห์ยาง</th>
                    <th width="40%" class="text-center">สาเหตุ</th>
                </tr>
                <tr>
                    <td class="text-center">1</td>
                    <td>
                        {{ content.data.product.return.productData.name }}
                        <span class="small" v-if="content.data.product.return.sku">SKU: {{ content.data.product.return.sku }}</span>
                    </td>
                    <td class="text-center">{{ content.data.product.return.dot }}</td>
                    <td>{{ content.data.product.cause }}</td>
                </tr>
            </table>

            <br />

            <table cellpadding="0" cellspacing="0">
                <tr>
                    <th width="5%" class="text-center"></th>
                    <th width="40%">สินค้าที่เปลี่ยนใหม่</th>
                    <th class="text-center">สัปดาห์ยาง</th>
                    <th class="text-center">จำนวนเงินชำระเพิ่ม</th>
                </tr>
                <tr>
                    <td class="text-center">1</td>
                    <td>
                        {{ content.data.product.replace.productData.name }}
                        <span class="small" v-if="content.data.product.replace.sku">SKU: {{ content.data.product.replace.sku }}</span>
                    </td>
                    <td class="text-center">{{ content.data.product.replace.dot }}</td>
                    <td class="text-center">{{ appHelper.getCommaNumber(content.data.product.additionalPrice) }}</td>
                </tr>
                <tr class="line space-top">
                    <td colspan="3" class="text-right">รวมเงิน</td>
                    <td class="text-center">{{ appHelper.getCommaNumber(content.data.product.additionalPrice) }}</td>
                </tr>
                <tr class="space-bottom">
                    <td colspan="3" class="text-right">ภาษีมูลค่าเพิ่ม</td>
                    <td class="text-center">xxxxx</td>
                </tr>
                <tr class="line footer">
                    <td colspan="3" class="text-right">จำนวนเงินทั้งสิ้น</td>
                    <td class="text-center">{{ appHelper.getCommaNumber(content.data.product.additionalPrice) }}</td>
                </tr>
            </table>

            <div class="remark">
                <strong>หมายเหตุ</strong> {{ content.store.remark.claim }}
            </div>

            <div class="signature">
                <div class="col space"></div>
                <div class="col license">
                    <div class="line"></div>
                    <div class="date">&nbsp;</div>
                    <label>ผู้รับเคลม</label>
                </div>
                <div class="col space"></div>
                <div class="col license">
                    <div class="line"></div>
                    <div class="date">&nbsp;</div>
                    <label>ผู้ขอเคลม</label>
                </div>
                <div class="col space"></div>
            </div>
        </section>
    </div>
</template>

<script>
import Helper from '@/resources/Helper';
import OptionLicensePlateProvince from '@/database/staticOption/LicensePlateProvince';

export default {
    data() {
        return {
            content: null,
            paperStyle: '',
            localStyle: `
                .paper table td {
                    vertical-align: middle;
                }
            `,
            customerTaxId: '',
            appHelper: Helper
        }
    },
    props: {
        fields: Object,
        globalStyle: String
    },
    watch: {
        fields(value) {
            this.content = value;
            this.getTaxId();
        }
    },
    mounted() {
        this.setupPaperStyle();
    },
    methods: {
        setupPaperStyle() {
            this.paperStyle = [ '<style>', this.globalStyle, this.localStyle, '</style>' ].join('');
        },
        getTaxId() {
            this.customerTaxId = '';

            if (this.content.data.customer.billTax) {
                this.customerTaxId = this.content.data.customer.billTax;
            }
        },
        getCarData() {
            return [ this.content.data.customer.carBrand, this.content.data.customer.carModel, this.content.data.customer.carYearSerie ].filter(Boolean).join(' ');
        },
        getLicensePlateData() {
            return [ this.content.data.customer.licensePlate, ' (' + OptionLicensePlateProvince.service.getValueByKey(this.content.data.customer.licensePlateProvince) + ')'].join(' ');
        }
    }
}
</script>